import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['range', 'field', 'output']
  static values = {
    monthLabel: String,
    yearOne: String,
    yearOther: String,
    step: { type: Number, default: 12 }
  }

  connect () {
    this.render()
  }

  render () {
    if (!this.hasRangeTarget || !this.hasOutputTarget) return

    const months = this.snap(this.rangeTarget.value)
    this.rangeTarget.value = String(months)
    if (this.hasFieldTarget) this.fieldTarget.value = String(months)
    const years = Math.floor(months / 12)
    const yearLabel = years === 1 ? this.yearOneValue : this.yearOtherValue
    this.outputTarget.textContent = `${months} ${this.monthLabelValue} · ${years} ${yearLabel}`
  }

  snap (raw) {
    const min = Number(this.rangeTarget.min) || 0
    const max = Number(this.rangeTarget.max) || min
    const numeric = Number(raw)
    if (!Number.isFinite(numeric)) return min

    const snapped = Math.round(numeric / this.stepValue) * this.stepValue
    return Math.min(max, Math.max(min, snapped))
  }
}
